import { render, staticRenderFns } from "./BouncingDots.vue?vue&type=template&id=5d2c0248"
import script from "./BouncingDots.vue?vue&type=script&lang=js"
export * from "./BouncingDots.vue?vue&type=script&lang=js"
import style0 from "./BouncingDots.vue?vue&type=style&index=0&id=5d2c0248&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports